// @Flow
import Vue from 'vue'
import type { B2bClientInterface } from '../../../services/b2b/b2b-client-interface'
import * as mutationTypes from './mutation-types'
import type { TripsPage } from '../../../types/tls-products-page'

export default {
  loadTrips: async ({ commit, state }: { commit: (string, TripsPage) => void }, cardId): Promise<void> => {
    try {
      const client: B2bClientInterface = Vue.prototype.$container.b2bClient
      commit(mutationTypes.SET_TRIPS_PAGE, await client.getCardTrips(
        cardId,
        state.pageNumber,
        state.pageSize,
        state.filterInvoiceNumber,
        state.filterCheckinMonth,
        state.filterCheckinDateFrom,
        state.filterCheckinDateTo,
        state.orderBy,
        state.orderDirection
      ))
    } catch (e) {
      throw e
    }
  },
  loadFilterMonths: async ({ commit, state }: { commit: (string, string[]) => void }, cardId): Promise<void> => {
    try {
      const client: B2bClientInterface = Vue.prototype.$container.b2bClient
      const list = await client.getCardTripFilterMonths(cardId)
      commit(mutationTypes.SET_TRIPS_FILTER_MONTHS, list.items)
    } catch (e) {
      commit(mutationTypes.SET_TRIPS_FILTER_MONTHS, null)
      throw e
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/trip/actions.js